import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { useTheme } from '@mui/material/styles';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import Modal from '@mui/material/Modal';
import { useState, useEffect, useRef } from 'react';

import ModalElement from './ModalElement';
import SnowflakeIcon from '../icons/SnowflakeIcon';

const apptType = [
  {
    name: 'Substance Use',
    alertType: 'SU',
    Icon: SnowflakeIcon,
    colors: {
      icon: '#f68b33',
      background: '#F3E8DC',
    },
    description: null,
  },
  {
    name: 'Mental Health',
    alertType: 'MH',
    Icon: SnowflakeIcon,
    colors: {
      icon: '#85b1e0',
      background: '#E7F1F7',
    },
    description: null,
  },
  {
    name: 'Co-Occurring',
    alertType: 'CO',
    Icon: SnowflakeIcon,
    colors: {
      icon: '#3c8e77',
      background: '#E6F4F1',
    },
    description: null,
  },
];

export default function Alert() {
  const theme = useTheme();
  const [mobile, setMobile] = useState(null);
  const [open, setOpen] = useState(false);
  const selectedRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth < 1000) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <Box
        sx={{
          padding: '80px',
          display: 'flex',
          flexDirection: 'column',
          gap: '80px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: mobile ? 'column' : 'row',
            gap: '40px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {apptType.map((option, idx) => {
            const {
              name,
              alertType,
              Icon,
              colors: { icon, background },
            } = option;
            return (
              <Card
                key={idx}
                sx={{
                  width: '300px',
                  height: '400px',
                  backgroundColor: background,
                  cursor: 'pointer',
                  boxShadow: `6px 0 12px ${theme.palette.grey['400']}`,
                  borderBottom: `3px solid ${icon}`,
                }}
                onClick={() => {
                  setOpen(true);
                  selectedRef.current = option;
                }}
              >
                <CardContent
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    opacity: '80%',
                    '&:hover': {
                      opacity: '100%',
                    },
                  }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        height: '80px',
                        color: icon,
                        fontWeight: 'bold',
                        fontSize: '25px',
                      }}
                    >
                      {name}
                    </Typography>
                    <Box sx={{ fontSize: '75px' }}>
                      <Icon
                        color={icon}
                        height={'100%'}
                        width={'100%'}
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            );
          })}
        </Box>
      </Box>
      <ModalElement
        open={open}
        handleClose={() => {
          selectedRef.current = null;
          setOpen(false);
        }}
        displayName={selectedRef.current?.name ?? ''}
        alertType={selectedRef.current?.alertType ?? ''}
      />
    </>
  );
}
